import {useEffect,useState} from 'react';

// Keep a single scroll surface above the software keyboard. Never lock touch/zoom.
export function viewportState(win,focused,baseline){
 const viewport=win.visualViewport,height=viewport?.height||win.innerHeight,top=viewport?.offsetTop||0;
 return {height,top,keyboard:!!focused&&Math.max(win.innerHeight,baseline)-height>120&&(viewport?.scale||1)<1.1};
}
export default function useFormViewport(root){
 const [state,setState]=useState(()=>({height:window.visualViewport?.height||window.innerHeight,top:0,keyboard:false}));
 useEffect(()=>{
  let frame,baseline=window.innerHeight,width=window.innerWidth;
  const request=window.requestAnimationFrame?.bind(window)||(fn=>window.setTimeout(fn,0)),cancel=window.cancelAnimationFrame?.bind(window)||window.clearTimeout.bind(window);
  const update=event=>{
   cancel(frame);
   frame=request(()=>{
    const active=document.activeElement,focused=root.current?.contains(active)&&active?.matches('input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=file]),textarea,select');
    if(width!==window.innerWidth){width=window.innerWidth;baseline=window.innerHeight;}
    if(!focused)baseline=Math.max(window.innerHeight,window.visualViewport?.height||0);
    const next=viewportState(window,focused,baseline);setState(old=>old.height===next.height&&old.top===next.top&&old.keyboard===next.keyboard?old:next);
    if(focused&&next.keyboard&&event?.type!=='scroll'){
     const rect=active.getBoundingClientRect();
     if(rect.top<next.top+60||rect.bottom>next.top+next.height-24)active.scrollIntoView?.({block:'nearest',inline:'nearest',behavior:'auto'});
    }
   });
  };
  const viewport=window.visualViewport;
  window.addEventListener('resize',update);viewport?.addEventListener('resize',update);viewport?.addEventListener('scroll',update);
  document.addEventListener('focusin',update);document.addEventListener('focusout',update);update();
  return()=>{cancel(frame);window.removeEventListener('resize',update);viewport?.removeEventListener('resize',update);viewport?.removeEventListener('scroll',update);document.removeEventListener('focusin',update);document.removeEventListener('focusout',update);};
 },[root]);
 return {style:{'--career-visible-height':state.height+'px','--career-visible-top':state.top+'px'},keyboard:state.keyboard};
}
